<div class="rail-content">

  <!-- 1 · Product-type pill tabs (4-up) — preserved from prior rail -->
  <div class="rail-tabs-block">
    <div class="rail-pill-tabs">
      @for (tab of tabs; track tab.id) {
        <button
          type="button"
          class="rail-pill-tab"
          [class.active]="activeTab() === tab.id"
          (click)="onPillClick(tab.id)"
        >
          {{ tab.label }}
          <!-- Scheduled-change count. Absent until that tab's feed has loaded,
               so an unloaded tab shows nothing rather than a misleading 0.
               `tabs` is a static list on this branch, so every pill can carry a
               badge — see the note in rates-filter-state.service.ts for why that
               discloses nothing the pill did not already. -->
          <!-- @if (changeCount(tab.id); as n) {
            <span class="rail-pill-badge" [title]="n + ' scheduled rate change' + (n === 1 ? '' : 's')">{{ n }}</span>
          } -->
        </button>
      }
    </div>
  </div>

  <!-- 1b · Scope (My Shelf / All Products). Frames the data universe
       the filters operate over. Mirrors the products rail's Scope
       section so the two surfaces feel consistent. -->
  <div class="rail-scope rail-scope-grp">
    <div class="scope-label">Scope</div>
    @if (showShelfScope()) {
      <div class="scope-row">
        <span class="scope-row-label">Products</span>
        <div class="shelf-switch"
             [class.shelf-switch-disabled]="shelfState() === 'disabled'"
             [attr.title]="shelfState() === 'disabled' ? 'Select a user via Admin to enable' : 'Toggle between all products and your shelf'">
          <span class="shelf-sw-opt"
                [class.shelf-sw-active]="shelfState() === 'off'"
                (click)="onShelfClick()">All</span>
          <span class="shelf-sw-opt"
                [class.shelf-sw-active]="shelfState() === 'on'"
                (click)="onShelfClick()">My Shelf</span>
        </div>
      </div>
    }
    <!-- Float is a SORT, so it sits beside the change filter rather than inside
         it. The switch above answers "which rows do I want"; this answers
         "where do they go", and the useful combinations need both. -->
    <div class="scope-row">
      <span class="scope-row-label">Float changes to top</span>
      <button type="button" class="float-sw" role="switch"
              [class.on]="floatChanges()"
              [attr.aria-checked]="floatChanges()"
              (click)="onToggleFloat()"
              title="Move rows with a scheduled change to the top, keeping every other row in place"></button>
    </div>
  </div>

  <!-- 2 · Scrollable middle: Saved Views · Applied Filters · Filters · Pinned · inactive -->
  <div class="rail-scroll">

    <!-- Criteria (case editor) — Basic Search REMOVED 2026-06-15. The exposed
         knobs (State/Premium/Term/Rating) already live in their Advanced-
         filter groups (State Availability · Premium · Surr Years ·
         A.M. Best), so the rail default is just Filters + Saved Views. This
         section now renders ONLY when casesEnabled is flipped on (Cases
         resurrection); the inner @else "Basic Search" branches are then
         unreachable but kept inert for that path. -->
    @if (showCriteria() && sessionCtx.casesEnabled()) {
    <div class="rail-section criteria-section" [class.is-open]="criteriaOpen()">
      <button type="button" class="section-hdr crit-hdr" (click)="toggleCriteria()">
        <svg class="sec-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
        <span class="ch-dot" aria-hidden="true"></span>
        <span class="ch-title">{{ sessionCtx.casesEnabled() ? 'Criteria' : 'Basic Search' }}</span>
        @if (sessionCtx.casesEnabled()) {
          @if (caseLoaded()) {
            <span class="ch-who">· {{ caseName() }}</span>
            @if (caseModified()) { <span class="ch-badge">exploring</span> }
          } @else {
            <span class="ch-who ch-none">· none</span>
          }
        }
      </button>
      <div class="section-body crit-body">
        @if (sessionCtx.casesEnabled()) {
          <div class="crit-knob crit-case-pick">
            <label>Case</label>
            <select [ngModel]="activeCaseId()" (ngModelChange)="onCasePick($event)" title="Load or switch the active case">
              <option [ngValue]="null">— No case —</option>
              @if (boundCases().length) {
                <optgroup label="Cases">
                  @for (c of boundCases(); track c.id) { <option [ngValue]="c.id">{{ c.name }}</option> }
                </optgroup>
              }
              @if (personaCases().length) {
                <optgroup label="Personas">
                  @for (p of personaCases(); track p.id) { <option [ngValue]="p.id">{{ p.name }}</option> }
                </optgroup>
              }
            </select>
            <app-case-picker-flyout [cases]="caseList()" [activeId]="activeCaseId()" (pick)="onCasePick($event)"></app-case-picker-flyout>
          </div>
          @if (caseLoaded()) {
            <button type="button" class="crit-edit-case" (click)="editCase()">Edit full case →</button>
          }
        }
        <p class="crit-sub">
          @if (sessionCtx.casesEnabled()) {
            @if (caseAllMode()) { Showing all rows — the ones that fit this client are marked ✓. }
            @else if (caseLoaded()) { This client's criteria — the grid filters live as you change them. }
            @else { Set criteria to filter the grid — then save them as a persona for reuse. }
          } @else {
            A few common filters — they drive the same grid filters as Advanced. Save the result as a view.
          }
        </p>

        <div class="crit-grid">
          <div class="crit-cell">
            <label>State</label>
            <select [(ngModel)]="kState" [disabled]="caseAllMode()">
              <option value="">— any —</option>
              @for (s of statesList; track s) { <option [value]="s">{{ s }}</option> }
            </select>
          </div>
          <div class="crit-cell full">
            <label>Premium</label>
            <span class="crit-money"><span class="crit-pre">$</span><input type="number" [ngModel]="kPremium" (ngModelChange)="kPremium = $event" [disabled]="caseAllMode()" placeholder="—" /></span>
          </div>
          <div class="crit-cell full">
            <label>Term (yr)</label>
            <span class="crit-range">
              <input type="number" [ngModel]="kTermMin" (ngModelChange)="kTermMin = $event" [disabled]="caseAllMode()" placeholder="Min" />
              <span class="crit-dash">–</span>
              <input type="number" [ngModel]="kTermMax" (ngModelChange)="kTermMax = $event" [disabled]="caseAllMode()" placeholder="Max" />
            </span>
          </div>
          <div class="crit-cell">
            <label>Rating ≥</label>
            <select [(ngModel)]="kRating" [disabled]="caseAllMode()">
              <option value="">Any</option>
              <option value="A-">A-</option>
              <option value="A">A</option>
              <option value="A+">A+</option>
              <option value="A++">A++</option>
            </select>
          </div>
        </div>

        @if (sessionCtx.casesEnabled() && caseLoaded()) {
          <div class="crit-mode-row">
            <span class="crit-mode-seg" role="group" aria-label="Case lens mode">
              <button type="button" [class.on]="!caseAllMode()" (click)="setCaseFit()" title="Narrow the grid to rows that fit this client">Fit only</button>
              <button type="button" [class.on]="caseAllMode()" (click)="setCaseAll()" title="Show every row; mark the ones that fit with ✓">Show all</button>
            </span>
          </div>
        }

        <div class="crit-foot">
          <span class="crit-count">
            @if (sessionCtx.casesEnabled() && hasAnyCriteria()) { <b>{{ fitCount() }}</b> of {{ totalCount() }} fit }
            @else { {{ totalCount() }} products }
          </span>
          <span class="crit-actions">
            @if (sessionCtx.casesEnabled()) {
              @if (caseLoaded()) {
                @if (caseAllMode()) {
                  <span class="crit-fav-note" [class.is-full]="favoriteCount() >= favoriteMax"
                        title="Hand-pick a few favorites with the ★ on each row">
                    ★ {{ favoriteCount() }}/{{ favoriteMax }} on case
                  </span>
                } @else {
                  <button type="button" class="crit-btn ghost" (click)="resetToCase()" title="Revert to the saved values">↺ Reset</button>
                  @if (isPersona()) {
                    <button type="button" class="crit-btn ghost" (click)="promoteToCase()" title="Attach a client — turn this persona into a real case">Promote →</button>
                    <button type="button" class="crit-btn amber" (click)="saveToCase()" [disabled]="!caseModified()">Save persona</button>
                  } @else {
                    <button type="button" class="crit-btn amber" (click)="saveToCase()" [disabled]="!caseModified()">Save to case</button>
                  }
                }
              } @else {
                <button type="button" class="crit-btn ghost" (click)="clearCriteria()" [disabled]="!hasAnyCriteria()">↺ Clear</button>
                <button type="button" class="crit-btn amber" (click)="saveAsPersona()" [disabled]="!hasAnyCriteria()">Save as persona</button>
              }
            } @else {
              <!-- Basic Search (cases parked): clear the knobs. -->
              <button type="button" class="crit-btn ghost" (click)="clearCriteria()" [disabled]="!hasAnyCriteria()">↺ Clear</button>
            }
          </span>
        </div>
      </div>
    </div>
    }

    <!-- Applied Filters block removed 2026-06-01: replaced by "footprints"
         chip strip rendered next to the page-header title (see
         rates.component.html → .ph-footprints). The rail's
         activeAppliedFilters() computed is still exported (as `appliedFilters`)
         so the same view source can be consumed by the parent component
         for footprint rendering — single source of truth, no per-tab drift. -->

    <!-- Filters section (relocated from right-side AG Grid tool panel) -->
    <!-- 2026-06-04 refinement #1: outer "Filter the filters" search input
         and its kbd-hint were removed. Picker has its own scoped search;
         users discover dims by scanning group headers. -->
    <div class="rail-section filters-section" [class.is-open]="filtersOpen()">
      <button type="button" class="section-hdr" (click)="toggleFilters()">
        <svg class="sec-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M9 6l6 6-6 6"/>
        </svg>
        <span>Filters</span>
      </button>
      <div class="section-body filters-body">

        <!-- Company & Product group — three uniform sub-items:
             Companies & Products picker · A.M. Best · Premium Type.
             2026-06-04 refinement #4: the carrier picker is now wrapped
             in a rail-field-style sub-item so all three children of the
             group share the same expand/collapse machinery. Default
             carrierSubOpen=true so the first expansion of the parent
             group reveals the picker without an extra click. -->
        <div class="tp-group" [class.is-open]="isGroupOpen('carrier')">
          <button type="button" class="tp-group-hdr" (click)="toggleGroup('carrier')">
            <svg class="ico-sm tg-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M9 6l6 6-6 6"/>
            </svg>
            <span>Company &amp; Product</span>
            <span class="tg-summary" [class.is-active]="groupActive('carrier')">{{ groupBadge('carrier') }}</span>
          </button>
          <div class="tp-group-body">
            <div data-dim="carrier" class="carrier-sub" [class.is-open]="carrierSubOpen()">
              <button type="button" class="rail-field-head carrier-sub-head"
                      [attr.aria-expanded]="carrierSubOpen()"
                      (click)="toggleCarrierSub()">
                <span class="rf-name">Carriers</span>
                @if (companyFilterSummary().count === null) {
                  <span class="rf-allnone">All</span>
                } @else {
                  <span class="rf-summary">{{ companyFilterSummary().label }}</span>
                }
              </button>
              @if (carrierSubOpen()) {
                <div class="carrier-picker-wrap">
                  <app-company-product-picker
                    mode="companies-only"
                    [dataInput]="pickerData()"
                    [initialSelection]="pickerInitialSelection()"
                    [externalSearchQuery]="pageSearchText()"
                    (selectionChange)="onPickerSelectionChange($event)"
                    (rowClick)="onCarrierRowClick($event)" />
                </div>
              }
            </div>
            <div data-dim="premiumType">
              <app-inline-picker-host
                dimensionKey="prem-type"
                [pinDimKey]="'premiumTypes'"
                [optionsFn]="premTypeOptionsFn"
                [pinned]="pinSvc.isPinned('premiumTypes')"
                [summary]="summaryFor('premiumType')"
                [highlightQuery]="''"
                (pinToggle)="onPinToggle($event)"
                (closeRequest)="onPickerCloseRequest($event)" />
            </div>
            <div data-dim="amBest">
              <app-inline-picker-host
                dimensionKey="am-best"
                [pinDimKey]="'amBest'"
                [optionsFn]="amBestOptionsFn"
                [pinned]="pinSvc.isPinned('amBest')"
                [summary]="summaryFor('amBest')"
                [highlightQuery]="''"
                (pinToggle)="onPinToggle($event)"
                (closeRequest)="onPickerCloseRequest($event)" />
            </div>
          </div>
        </div>

        <!-- Crediting Strategy group — Index/Combo/Mktg Name/Strategy Name
             are indexed-crediting concepts with no FA equivalent. -->
        @if (isNotFa()) {
        <div class="tp-group" [class.is-open]="isGroupOpen('crediting')">
          <button type="button" class="tp-group-hdr" (click)="toggleGroup('crediting')">
            <svg class="ico-sm tg-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M9 6l6 6-6 6"/>
            </svg>
            <span>Crediting Strategy</span>
            <span class="tg-summary" [class.is-active]="groupActive('crediting')">{{ groupBadge('crediting') }}</span>
          </button>
          <div class="tp-group-body">
            <div data-dim="mktg">
              <app-inline-picker-host
                dimensionKey="mktg"
                [pinDimKey]="null"
                [optionsFn]="mktgOptionsFn"
                [pinned]="false"
                [summary]="summaryFor('mktg')"
                [highlightQuery]="''"
                (pinToggle)="onPinToggle($event)"
                (closeRequest)="onPickerCloseRequest($event)" />
            </div>
            <div data-dim="index">
              <app-inline-picker-host
                dimensionKey="index"
                [pinDimKey]="'indexes'"
                [optionsFn]="indexOptionsFn"
                [pinned]="pinSvc.isPinned('indexes')"
                [summary]="summaryFor('index')"
                [highlightQuery]="''"
                (pinToggle)="onPinToggle($event)"
                (closeRequest)="onPickerCloseRequest($event)" />
            </div>
            <div data-dim="crediting">
              <app-inline-picker-host
                dimensionKey="strat"
                [pinDimKey]="'strategies'"
                [optionsFn]="stratOptionsFn"
                [pinned]="pinSvc.isPinned('strategies')"
                [summary]="summaryFor('crediting')"
                [highlightQuery]="''"
                (pinToggle)="onPinToggle($event)"
                (closeRequest)="onPickerCloseRequest($event)" />
            </div>
            <!-- RILA/VA filter block (2026-06-05) — five Crediting-group sub-items
                 rendered only on RILA + VA tabs. -->
            @if (isRilaOrVa()) {
              <div data-dim="bufferLevel">
                <app-inline-picker-host
                  dimensionKey="buffer-level"
                  [pinDimKey]="'bufferLevel'"
                  [optionsFn]="bufferLevelOptionsFn"
                  [pinned]="pinSvc.isPinned('bufferLevel')"
                  [summary]="summaryForRilaVa('buffer-level')"
                  [highlightQuery]="''"
                  (pinToggle)="onPinToggle($event)"
                  (closeRequest)="onPickerCloseRequest($event)" />
              </div>
              <div data-dim="floorLevel">
                <app-inline-picker-host
                  dimensionKey="floor-level"
                  [pinDimKey]="'floorLevel'"
                  [optionsFn]="floorLevelOptionsFn"
                  [pinned]="pinSvc.isPinned('floorLevel')"
                  [summary]="summaryForRilaVa('floor-level')"
                  [highlightQuery]="''"
                  (pinToggle)="onPinToggle($event)"
                  (closeRequest)="onPickerCloseRequest($event)" />
              </div>
              <div data-dim="segmentDuration">
                <app-inline-picker-host
                  dimensionKey="segment-duration"
                  [pinDimKey]="'segmentDuration'"
                  [optionsFn]="segmentDurationOptionsFn"
                  [pinned]="pinSvc.isPinned('segmentDuration')"
                  [summary]="summaryForRilaVa('segment-duration')"
                  [highlightQuery]="''"
                  (pinToggle)="onPinToggle($event)"
                  (closeRequest)="onPickerCloseRequest($event)" />
              </div>
              <div data-dim="rateType">
                <app-inline-picker-host
                  dimensionKey="rate-type"
                  [pinDimKey]="'rateType'"
                  [optionsFn]="rateTypeOptionsFn"
                  [pinned]="pinSvc.isPinned('rateType')"
                  [summary]="summaryForRilaVa('rate-type')"
                  [highlightQuery]="''"
                  (pinToggle)="onPinToggle($event)"
                  (closeRequest)="onPickerCloseRequest($event)" />
              </div>
              <div data-dim="protectionType">
                <app-inline-picker-host
                  dimensionKey="protection-type"
                  [pinDimKey]="'protectionType'"
                  [optionsFn]="protectionTypeOptionsFn"
                  [pinned]="pinSvc.isPinned('protectionType')"
                  [summary]="summaryForRilaVa('protection-type')"
                  [highlightQuery]="''"
                  (pinToggle)="onPinToggle($event)"
                  (closeRequest)="onPickerCloseRequest($event)" />
              </div>
            }
          </div>
        </div>
        }

        <!-- Surrenders & Premium group -->
        <div class="tp-group" [class.is-open]="isGroupOpen('surrenders')">
          <button type="button" class="tp-group-hdr" (click)="toggleGroup('surrenders')">
            <svg class="ico-sm tg-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M9 6l6 6-6 6"/>
            </svg>
            <span>Premium</span>
            <span class="tg-summary" [class.is-active]="groupActive('surrenders')">{{ groupBadge('surrenders') }}</span>
          </button>
          <div class="tp-group-body">
            <!-- RILA has no other dimension in this group, so the Premium row
                 would be a second "Premium" accordion directly under the group
                 header: render its input straight in the body instead. -->
            <div data-dim="premium">
              <app-inline-picker-host
                dimensionKey="contribution"
                [headless]="activeTab() === 'RILA'"
                [pinDimKey]="'premium'"
                [optionsFn]="emptyOptions"
                [pinned]="pinSvc.isPinned('premium')"
                [summary]="summaryFor('premium')"
                [highlightQuery]="''"
                (pinToggle)="onPinToggle($event)"
                (closeRequest)="onPickerCloseRequest($event)" />
            </div>
            @if (activeTab() !== 'FA' && activeTab() !== 'RILA') {
              <div data-dim="surrYears">
                <app-inline-picker-host
                  dimensionKey="surr"
                  [pinDimKey]="'surrYrs'"
                  [optionsFn]="surrOptionsFn"
                  [pinned]="pinSvc.isPinned('surrYrs')"
                  [summary]="summaryFor('surrYears')"
                  [highlightQuery]="''"
                  (pinToggle)="onPinToggle($event)"
                  (closeRequest)="onPickerCloseRequest($event)" />
              </div>
            }
            @if (activeTab() === 'FA') {
              <div data-dim="faRateTerm">
                <app-rail-fa-checklist-picker
                  field="rateTerm"
                  [pinned]="pinSvc.isPinned('faRateTerm')"
                  (pinToggle)="onPinToggle($event)"
                  (closeRequest)="onPickerCloseRequest($event)" />
              </div>
              <div data-dim="faSurrYears">
                <app-rail-fa-checklist-picker
                  field="surrYears"
                  [pinned]="pinSvc.isPinned('faSurrYears')"
                  (pinToggle)="onPinToggle($event)"
                  (closeRequest)="onPickerCloseRequest($event)" />
              </div>
              <div data-dim="faBonusYears">
                <app-rail-fa-checklist-picker
                  field="bonusYears"
                  [pinned]="pinSvc.isPinned('faBonusYears')"
                  (pinToggle)="onPinToggle($event)"
                  (closeRequest)="onPickerCloseRequest($event)" />
              </div>
            }
          </div>
        </div>

        <!-- Riders & Features group -->
        <div class="tp-group" [class.is-open]="isGroupOpen('riders')">
          <button type="button" class="tp-group-hdr" (click)="toggleGroup('riders')">
            <svg class="ico-sm tg-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M9 6l6 6-6 6"/>
            </svg>
            <span>Riders</span>
            <span class="tg-summary" [class.is-active]="groupActive('riders')">{{ groupBadge('riders') }}</span>
          </button>
          <div class="tp-group-body">
            <!-- Riders is the group's only picker (the ROP/Inverse/... toggles
                 below aren't one), so it renders open with no "Riders" row
                 repeating the group header. -->
            <div data-dim="riders">
              <app-inline-picker-host
                dimensionKey="riders"
                [headless]="true"
                [pinDimKey]="'riders'"
                [optionsFn]="ridersOptionsFn"
                [pinned]="pinSvc.isPinned('riders')"
                [summary]="summaryFor('riders')"
                [highlightQuery]="''"
                (pinToggle)="onPinToggle($event)"
                (closeRequest)="onPickerCloseRequest($event)" />
            </div>
            <div class="rail-toggles">
              <button type="button" class="rail-toggle" [class.on]="togglesActive().rop"  (click)="onRopClick()">ROP</button>
              @if (activeTab() === 'IA') {
                <button type="button" class="rail-toggle" [class.on]="togglesActive().bail" (click)="onBailClick()">Bail Out</button>
              }
              @if (activeTab() === 'FA') {
                <button type="button" class="rail-toggle" [class.on]="togglesActive().bonus"  (click)="onBonusClick()">Rate Bonus</button>
              }
              @if (activeTab() !== 'FA') {
                <button type="button" class="rail-toggle" [class.on]="togglesActive().inverse" (click)="onInverseClick()">Inverse</button>
              }
              @if (activeTab() === 'FA') {
                <button type="button" class="rail-toggle" [class.on]="togglesActive().faMva" (click)="onFaMvaClick()">MVA</button>
                <button type="button" class="rail-toggle" [class.on]="togglesActive().faQualified" (click)="onFaQualifiedClick()">Qualified</button>
              }
            </div>
          </div>
        </div>

        <!-- State Availability group -->
        <div class="tp-group" [class.is-open]="isGroupOpen('states')">
          <button type="button" class="tp-group-hdr" (click)="toggleGroup('states')">
            <svg class="ico-sm tg-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M9 6l6 6-6 6"/>
            </svg>
            <span>State Availability</span>
            <span class="tg-summary" [class.is-active]="groupActive('states')">{{ groupBadge('states') }}</span>
          </button>
          <!-- The grid IS the group body. This group holds exactly one
               dimension, so the picker row that used to sit here was a second
               accordion whose only job was to open the one thing the group
               already promised — two clicks to reach the states, and a "State"
               label directly under "State Availability". The group header still
               carries the summary via groupBadge('states'), so nothing moved
               out of view with it. data-dim stays: scrollDimIntoView() and
               expandGroupContaining() find the dimension by it. -->
          <div class="tp-group-body">
            <div data-dim="states">
              <app-state-grid-picker />
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Pinned · inactive (visible when ≥ 1 pinned dim has no value) -->
    @if (pinnedInactive().length > 0) {
      <div class="rail-section" [class.is-open]="pinnedInactiveOpen()">
        <button type="button" class="section-hdr" (click)="togglePinnedInactive()">
          <svg class="sec-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M9 6l6 6-6 6"/>
          </svg>
          <span>Pinned · inactive</span>
          <span class="sec-count">{{ pinnedInactive().length }}</span>
        </button>
        <div class="section-body">
          @for (f of pinnedInactive(); track f.dim) {
            <app-applied-filter-row
              variant="pinned-inactive"
              [dim]="f.dim"
              [dimLabel]="f.label"
              valueSummary="any"
              [pinned]="true"
              (rowClick)="onRowJump($event)"
            />
          }
        </div>
      </div>
    }

    <div class="rail-spacer"></div>
  </div>

</div>
